import { Box, Grid } from '@mui/material';
import { WsColors, WsTitleBanner } from 'wisestep-base';

import { IOption } from '../../../components/SettingsIndex';
import TeamsOptions from '../../../components/TeamsOptions';
import { WsBreadCrumbs } from '../../../components/WsBreadCrumbs';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import { PromptSettingOptionsRoutes } from '../routes';

const PromptMainSetting = () => {
  const sideMenuOptions: IOption[] = [
    {
      label: 'Recruiter Question',
      url: '/prompt-settings/',
    },
    {
      label: 'Candidate Summary',
      url: '/prompt-settings/candidate-summary',
    },
  ];

  const currentZoom = window.devicePixelRatio;
  const xsSize = 2.4 * currentZoom;
  return (
    <Grid>
      <WsBreadCrumbs
        breadCrumbsList={getSettingBreadCrumbList(
          ISettingBreadCrumbTypes.APPS_AND_INTEGRATION,
          Pages['PROMPT_SETTINGS']
        )}
      />
      <Grid container display="flex">
        <>
          <Grid
            sx={{
              backgroundColor: WsColors.TheBlues900,
              borderRadius: 1.2,
              height: '90%',
              padding: 0,
              position: 'fixed',
            }}
            xs={xsSize}
          >
            <WsTitleBanner title={'Prompt Settings'} backButton={false} />
            <Box>
              <TeamsOptions bgColorforlist={true} options={sideMenuOptions} />
            </Box>
          </Grid>
        </>
        <Grid item xs={12} sx={{ marginLeft: 33 }}>
          <PromptSettingOptionsRoutes />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PromptMainSetting;
